export default "comment\nPourquoi\nCombien"